import React from "react";
const SvgMapAround = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="#1A1F24">
      <path d="M12 14a2 2 0 100-4 2 2 0 000 4z" />
      <path
        fillRule="evenodd"
        d="M12 3a9 9 0 100 18 9 9 0 000-18zm-8 9a8 8 0 1116 0 8 8 0 01-16 0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgMapAround;
